import { FuelPriceState, Location, StoreAddressFragment, StoreConfigurationFragment } from '@ocx/graphql';

export enum PriceType {
  CASH = 'cashPrice',
  CREDIT = 'creditPrice',
}

export interface IPrice {
  id: string;
  title: string;
  price: string;
  isDefault?: boolean;
  type: PriceType;
}

export type UnformattedPrice = Omit<IPrice, 'price'> & {
  price: number;
};

export type PriceGroup = {
  title: string;
  prices: IPrice[];
};

export interface IStore {
  location: Location;
  id: string;
  price: null | string;
  fuelPriceState: FuelPriceState | null;
  priceGroups: PriceGroup[];
  distance: number; // distance between customer and store
  searchDistance: number; // distance between current map position and store (used for filtering while searching by location)
  directionLink: string;
  addressLine1: string;
  addressLine2: string;
  lat: number;
  lng: number;
}

export interface Coordinates {
  lat: number;
  lng: number;
}

export interface IStoreCarWashOption {
  id: string;
  name: string;
  price: string | null;
  unitPrice: number;
  posCode: string;
  posCodeModifier: string;
  productCode: string | null;
}

export interface IStorePumpInfo {
  id: string;
  siteId: string;
  address: { addressLine1: string; addressLine2: string };
  pumps: string[];
  carWashOptions: IStoreCarWashOption[];
}

export type SanitizedStorePumpInfo = Pick<Location, 'uuid'> & {
  address: StoreAddressFragment;
  siteSystemConfiguration: [StoreConfigurationFragment];
};

export interface GoogleMapsOptions {
  zoom: number;
  minZoom: number;
  maxZoom: number;
  disableDefaultUI: boolean;
  mapId: string;
}
